<script lang="ts" setup>
const router = useRouter();
const route = useRoute();

const isDeepPage = computed(() => {
  return ['catalog', 'profile'].includes(route.name as string);
});

function onClick() {
  if (isDeepPage) return navigateTo(route.path.split('/').slice(0, -1).join('/'));

  router.back();
}
</script>

<template>
  <button @click="onClick">
    <SvgoChevronLeft
      :font-controlled="false"
      class="size-6"
      filled
    />
  </button>
</template>
